class GoogleAnalytics {
  // Usage: // this.$helpers.ga.openPage('contact');
  static openPage() {
  // static openPage(page) {
    // window.dataLayer.push({'event': 'event_name'});
      // eslint-disable-next-line
      // ga('set', 'page', `/${page}.html`);
      // eslint-disable-next-line
      // ga('send', 'pageview', `/${page}`);
  }
}

export default GoogleAnalytics;
